import React from "react";
import { Link } from "react-router-dom";
import { ROUTES } from "../routes";
import SiteFooter from "./SiteFooter";
import "./About.css";

const About: React.FC = () => {
  return (
    <main className="about-page">
      <div className="about-container">
        <h1>About Totties</h1>
        <p className="subtitle">
          Helping South Africans make smarter money decisions.
        </p>

        <div className="about-section">
          <h2>Our intention</h2>
          <p>
            The goal of Totties is to turn complex money questions into clear,
            practical guidance. We bring together reliable, up‑to‑date
            information and purpose‑built calculators so consumers and lenders
            can make smarter, more confident decisions.
          </p>
          <p>
            Everything here is free to use. We prioritise accuracy, transparency
            and simplicity over jargon — so you can focus on the choices that
            matter.
          </p>
          <p>
            If you find this tool useful, please consider supporting me by
            buying me a coffee.
          </p>
          <a
            href="https://www.buymeacoffee.com/totties"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png"
              alt="Buy Me a Coffee"
              width={217}
              height={41}
              loading="lazy"
            />
          </a>
        </div>

        <nav className="about-tools" aria-label="Calculators">
          <h2>Free calculators</h2>
          <ul>
            <li>
              <Link to={ROUTES.tax}>SARS income tax calculator</Link>
            </li>
            <li>
              <Link to={ROUTES.carAffordability}>Car affordability</Link>
            </li>
            <li>
              <Link to={ROUTES.homeAffordability}>Home affordability</Link>
            </li>
            <li>
              <Link to={ROUTES.bondRepayment}>Bond repayment</Link>
            </li>
            <li>
              <Link to={ROUTES.monthlyFinances}>Monthly finances</Link>
            </li>
          </ul>
        </nav>

        <SiteFooter />
      </div>
    </main>
  );
};

export default About;
